var map = {
	"./147contact.png": 90947,
	"./147phone.png": 8846,
	"./btnaccessoires.svg": 82497,
	"./btnback.svg": 8953,
	"./btnbody.svg": 62376,
	"./btnbottom.svg": 4006,
	"./btnclose.svg": 75475,
	"./btncontact.svg": 69118,
	"./btncontinue.svg": 95098,
	"./btnface.svg": 74222,
	"./btnhair.svg": 24376,
	"./btninfo.svg": 59736,
	"./btnlocked.svg": 67086,
	"./btnsettings.svg": 5931,
	"./btnshare.svg": 77199,
	"./btnshoes.svg": 19220,
	"./btnspeak.svg": 33151,
	"./btnspeak_no.svg": 30739,
	"./btnsurprise.svg": 47,
	"./btntop.svg": 27717
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60412;